import parseGatheringPreviewTemplateUrl from "src/helpers/parseV0TemplateUrl/parseGatheringPreviewTemplateUrl";
import { Image } from "src/swsh-native";
import usePhotoDetailStore from "../stores/usePhotoDetailStore";
import { PhotoItem } from "../types";

const CarouselPhotoItem = ({
	photo,
	width,
	height,
}: {
	photo: PhotoItem;
	width: number;
	height: number;
}) => {
	const shouldAttemptLoad = usePhotoDetailStore((state) => !state.isWaitingForInitialPhotoLoad);

	const src = parseGatheringPreviewTemplateUrl({ readUrl: photo.readUrl });

	if (!shouldAttemptLoad) return null;
	if (!src) return null;
	return (
		<Image
			alt="Preview photo"
			dim={{
				width,
				height,
			}}
			style={{
				borderRadius: 2,
			}}
			//blurHash={photo.blurHash}
			contentFit="cover"
			webLoadingBehavior="eager"
			src={src}
		/>
	);
};
export default CarouselPhotoItem;
